import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import {
  selectCompanyPaginator,
  selectCompanyProductFilter,
  selectCompanyProducts,
  selectItemsCount,
} from '../../selectors';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_ADD_COMPANY_PRODUCT, REQUEST_COMPANY_PRODUCTS } from '../../constants';
import { addCompanyProduct, changeCompanyProductsFilter, fetchCompanyProducts } from '../../actions';
import { BaseComponent } from '../../../../components/BaseComponent';
import { Loader } from '../../../../components/Loader';
import { PageHeader } from '../../../../components/PageHeader';
import { ChevronRight } from '../../../../components/Icon';
import { CompanyProductsOverviewTable } from './companyProductsOverviewTable';
import { Button } from '../../../../components/Buttons';
import { CompanyProductAddModal } from './companyProductAddModal';
import { HBox, VBox } from '../../../../components/Box';
import { CompanyProductSearch } from './Search';
import { Pagination } from '../../../../components/Pagination';

const Container = styled.div`
  .filters {
    padding: 24px;
    background-color: white;
    margin-bottom: 22px;
  }

  .form-control {
    margin-bottom: 0;
  }

  .nav-link {
    cursor: pointer;
  }

  .nav-link.active {
    color: blue;
  }
`;

const STATE = {
  currentPage: 0,
};

class CompanyProductsOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    this.props.fetch();
  }

  onClickAdd() {
    this.setState({ showAddModal: true });
  }

  addProduct(companyId, productId) {
    this.props.addProduct(companyId, productId, this.closeAddModal.bind(this));
  }

  closeAddModal() {
    this.setState({ showAddModal: false });
  }

  selectPage = newPage => {
    const newOffset = this.props.paginator.limit ? newPage * this.props.paginator?.limit : newPage * 50;
    this.setState({ currentPage: newPage }, this.props.changeFilter('offset', newOffset));
  };

  render() {
    if (this.props.work || !this.props.filter || !this.props.products) return <Loader small />;
    return (
      <Container>
        <PageHeader
          title={
            <>
              {this.lbl('company.details.columns.products')} <span className="label number">{this.props.count}</span>
            </>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('company.overview.title')}
              <ChevronRight />
              {this.props.company_id}
            </>
          }
        ></PageHeader>

        <div className="filters">
          <HBox right>
            <Button primary small onClick={this.onClickAdd.bind(this)}>
              +{this.lbl('add')}
            </Button>
          </HBox>
          <VBox left vCenter>
            <CompanyProductSearch />
          </VBox>
        </div>

        <div>
          <CompanyProductsOverviewTable products={this.props.products} companyId={this.props.company_id} />
        </div>
        {this.props.paginator?.itemsCount > this.props.paginator?.limit && (
          <Pagination paginator={this.props.paginator} selectPage={this.selectPage} />
        )}
        {this.state.showAddModal && (
          <CompanyProductAddModal
            companyId={this.props.company_id}
            onConfirm={this.addProduct.bind(this)}
            onClose={this.closeAddModal.bind(this)}
          />
        )}
      </Container>
    );
  }
}

CompanyProductsOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    products: selectCompanyProducts(),
    paginator: selectCompanyPaginator(),
    count: selectItemsCount(),
    work: selectWorks([REQUEST_COMPANY_PRODUCTS, REQUEST_ADD_COMPANY_PRODUCT]),
    filter: selectCompanyProductFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchCompanyProducts(ownProps.company_id));
    },
    changeFilter: (name, value) => {
      dispatch(changeCompanyProductsFilter(name, value));
    },
    addProduct: (companyId, productId, callback) => {
      dispatch(addCompanyProduct(companyId, productId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyProductsOverview = compose(withConnect, withRouter)(CompanyProductsOverviewComp);
